module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container"
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('el-input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "专业代码 / 名称"
    },
    model: {
      value: (_vm.queryForm.zydm),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "zydm", $$v)
      },
      expression: "queryForm.zydm"
    }
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "招生性质",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.zsxz),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "zsxz", $$v)
      },
      expression: "queryForm.zsxz"
    }
  }, _vm._l((_vm.comboOption.property), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "所属部系",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.xbdm),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "xbdm", $$v)
      },
      expression: "queryForm.xbdm"
    }
  }, _vm._l((_vm.comboOption.dept), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "国标专业代码 / 名称"
    },
    model: {
      value: (_vm.queryForm.gbzydm),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "gbzydm", $$v)
      },
      expression: "queryForm.gbzydm"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addRec
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-plus-outline"
  }), _vm._v(" 新建")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.tableLoading),
      expression: "tableLoading",
      modifiers: {
        "body": true
      }
    }],
    ref: "mainTable",
    attrs: {
      "data": _vm.tableData,
      "element-loading-text": "信息加载中",
      "stripe": "",
      "border": "",
      "fit": "",
      "highlight-current-row": "",
      "header-cell-class-name": "tableHeadStyle",
      "height": _vm.mainTableHeight
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "50",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.queryForm.pageNum - 1) * _vm.queryForm.rowNum + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "专业代码",
      "prop": "zydm",
      "width": "120px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "专业名称",
      "prop": "zymc",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "招生性质",
      "prop": "zsxzmc",
      "width": "120px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属系部",
      "prop": "xbmc",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学制",
      "prop": "xz",
      "width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "国标专业代码",
      "prop": "gbzydm",
      "width": "120px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "国标专业名称",
      "prop": "gbzymc",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "专业负责人",
      "prop": "zyzzxm",
      "width": "150px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "180px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.modRec(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        }), _vm._v(" 编辑\n                ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.delRec(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v(" 删除\n                ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-container"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryForm.pageNum,
      "page-sizes": [10, 20, 50],
      "page-size": _vm.queryForm.rowNum,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handlePageChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryForm, "pageNum", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryForm, "pageNum", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "customElRow",
    attrs: {
      "title": _vm.CurdDialogTitle,
      "visible": _vm.CurdDialogVisible,
      "width": "800px",
      "top": "150px"
    },
    on: {
      "update:visible": function($event) {
        _vm.CurdDialogVisible = $event
      },
      "closed": _vm.closeCurdDialog
    }
  }, [_c('el-form', {
    ref: "curdForm",
    attrs: {
      "model": _vm.curdForm,
      "label-width": "120px",
      "label-position": "left",
      "rules": _vm.CurdRules
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "专业代码",
      "prop": "zydm"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "placeholder": "系统自动生成"
    },
    model: {
      value: (_vm.curdForm.zydm),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "zydm", $$v)
      },
      expression: "curdForm.zydm"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "专业名称",
      "prop": "zymc"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.curdForm.zymc),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "zymc", $$v)
      },
      expression: "curdForm.zymc"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属系部",
      "prop": "xbdm"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": "",
      "disabled": _vm.editFlag
    },
    model: {
      value: (_vm.curdForm.xbdm),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "xbdm", $$v)
      },
      expression: "curdForm.xbdm"
    }
  }, _vm._l((_vm.comboOption.dept), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "招生性质",
      "prop": "zsxz"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": "",
      "disabled": _vm.editFlag
    },
    model: {
      value: (_vm.curdForm.zsxz),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "zsxz", $$v)
      },
      expression: "curdForm.zsxz"
    }
  }, _vm._l((_vm.comboOption.property), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学制",
      "prop": "xz"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 2,
      "max": 5,
      "precision": 1,
      "step": 0.5,
      "label": "请输入学制"
    },
    model: {
      value: (_vm.curdForm.xz),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "xz", $$v)
      },
      expression: "curdForm.xz"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "国标专业代码",
      "prop": "gbzydm"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.curdForm.gbzydm),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "gbzydm", $$v)
      },
      expression: "curdForm.gbzydm"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "国标专业名称",
      "prop": "gbzymc"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.curdForm.gbzymc),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "gbzymc", $$v)
      },
      expression: "curdForm.gbzymc"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "教育层次",
      "prop": "jycc"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.curdForm.jycc),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "jycc", $$v)
      },
      expression: "curdForm.jycc"
    }
  }, _vm._l((_vm.comboOption.level), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "专业负责人",
      "prop": "groupLeader"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "placeholder": "请选择",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.curdForm.groupLeader),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "groupLeader", $$v)
      },
      expression: "curdForm.groupLeader"
    }
  }, _vm._l((_vm.comboOption.leader), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.CurdDialogVisible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56752d51"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/baseInfo/major.vue
// module id = 1833
// module chunks = 502